export enum ResultTypes {
    affiliate = 'affiliate',
    notAffiliate = 'notAffiliate',
    notParticipate = 'notParticipate',
    wrong = 'wrong',
}

interface IDataType {
    link: string;
    cashbackCis: string;
    cashbackHotsale: string;
    cashbackNotCis: string;
    affiliateType: 0 | 1 | 2;
}

interface IAttributes {
    url: string;
    method: 'GET';
    body: [];
}

export interface IGroupedLinks {
    [ResultTypes.affiliate]: IDataType[];
    [ResultTypes.notAffiliate]: IDataType[];
    [ResultTypes.wrong]: IDataType[];
}

export interface IRequest {
    type: string;
    id: number;
    attributes: IAttributes;
}

export interface IResponses {
    data?: {
        attributes: {
            body: {
                request?: {
                    link?: string;
                    v?: string;
                    material?: string;
                };
                data?: {
                    attributes: IDataType;
                };
                errors?: {
                    error: number;
                    error_description: StorageManager;
                }[];
            };
        };
    }[];
}

export interface IResult {
    type: ResultTypes;
    data: IDataType[];
}
